import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import EntryFactorSave from "./EntryFactorSave";


const EntryFactorEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response45 = useInvoke("WebApps", "45", {"@EntryFactorID": id});
    
    const [entryFactor, setEntryFactor] = useState({});

    useEffect(() => {

        //get entry factor by id
        if (response45.data.payload != undefined) {
            let data = JSON.parse(response45.data.payload).data[0];

            let obj = {
                EntryFactorId: data[0],
                Factor: data[1],
                CreatedDate: data[2]
            }
            setEntryFactor(obj);
        }

    }, [response45.isPending]);

    const handleFormSubmit = (e) => {

        let entryfactorid = id;

        let valid = true;

        let factor = "";
        if (document.getElementById("entryFactor").value != '') {
            factor = document.getElementById("entryFactor").value;
            if(!isNaN(factor)) {
                let oldFactor = factor;
                factor = parseFloat(factor).toFixed(2);
                if(parseFloat(factor) != parseFloat(oldFactor)) {
                    toast(`Entry Factor rounded to ${factor} from ${oldFactor}`);
                }
            }
            else {
                toast.error("Entry Factor must be a number");
            }
        }
        else {
            factor = document.getElementById("entryFactor").defaultValue;
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
            EntryFactorSave(entryfactorid, factor, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/EntryFactor");
        }
    };

    document.title = "Entry Factor - Edit";
    return ( 
        <div className="entryFactorEdit">
            {user["email"] != undefined && 
                <>
                    {entryFactor && 
                        <div className="container body-content" style={{marginTop: "25px"}}>
                                
                            <h2>Edit Entry Factor</h2>

                            <form id="entryFactorForm" noValidate="novalidate" autoComplete="off">  

                                <div className="form-group">
                                    <label htmlFor="entryFactor">Entry Factor</label>
                                    <input className="form-control" id="entryFactor" name="entryFactor" type="text" defaultValue={entryFactor["Factor"]} autoComplete="off" />
                                </div>
            
                            </form>  
                            <Link to="/EntryFactor" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                              
                            <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                            
                        </div>
                    }
                </>
            }
        </div>
    );
}
 
export default EntryFactorEdit;